type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  readTutorials: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}
export type TutorialData = {
  cpf: string
  created_at: string
  deleted_at?: string
  email: string
  id: number
  name: string
  status: string
  type: string
  values?: string
  updated_at: string
}

export type TutorialsData = {
  id: number
  cpf: string
  name: string
  payment_form: string
  status: string
  values: number
  created_at: string
  updated_at: string
  deleted_at?: string
}

const nameEntity = 'Tutorial'
const nameSource = 'commercial/tutorials'
const namePageTitle = 'Tutoriais'
const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Tutoriais',
  to: '/commercial/tutorials',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/tutorials/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/tutorials/',
    icon: 'fa fa-list'
  },
  readTutorials: {
    name: 'Contratos',
    to: '/commercial/tutorials/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/tutorials/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
